<app-invoice *ngIf="english"></app-invoice>
<app-invoice-hindi *ngIf="hindi"></app-invoice-hindi>